import VoucherBatchListView from "../../components/VoucherBatchListView";

VoucherBatchListScreen.propTypes = {};

function VoucherBatchListScreen(props) {
    // MARK: ---- PROPERTIES ----

    return (
        <div>
            <div className="container-fluid px-4 my-4">
                <VoucherBatchListView />
            </div>
        </div>
    );
}

export default VoucherBatchListScreen;
